import { QuerySamplesForWorkbookQuery } from "./gql/Query.generated";
type QuerySample =
  QuerySamplesForWorkbookQuery["getQuerySamplesForWorkbook"][number];

export function hasDuplicatedSamples(
  samples: QuerySample[],
  newSampleIds: string[],
): boolean {
  const selectedParameters = samples
    .filter((sample) => newSampleIds.includes(sample.id))
    .map((sample) => JSON.stringify(sample.jsonParameters));
  return new Set(selectedParameters).size !== selectedParameters.length;
}
